// _components/onboarding/consultation/ConsultStep6.tsx

"use client";
import { motion } from "framer-motion";
import Image from "next/image";

type Step6Props = {
  onExplore: () => void;
};

export default function ConsultStep6({ onExplore }: Step6Props) {
  return (
    <div className="text-center">
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-semibold text-gray-800"
      >
        Form Completed!
      </motion.h1>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="mt-4 flex justify-center"
      >
        <Image
          src={"/assets/img/message-icon.svg"}
          width={100}
          height={100}
          alt="Success Icon"
          className="w-16 h-16"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="mt-4 text-sm text-gray-600"
      >
        Thank you! An agent will reach out shortly.
      </motion.p>

      <motion.button
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        onClick={onExplore}
        className="mt-8 px-8 py-3 rounded-full bg-green-800 text-white font-medium hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
      >
        Explore our Marketplace →
      </motion.button>
    </div>
  );
}
